export const ACCOUNT_PUT = 'ACCOUNT_PUT'
export const ACCOUNT_GET = 'ACCOUNT_GET'
export const ACCOUNT_STATUS_SET = 'ACCOUNT_STATUS_SET'
export const ACCOUNT_DELETE = 'ACCOUNT_DELETE'
export const ACCOUNT_FILES_GET = 'ACCOUNT_FILES_GET'
export const ACCOUNT_FILE_GET = 'ACCOUNT_FILE_GET'
export const ACCOUNT_FILE_PUT = 'ACCOUNT_FILE_PUT'
export const ACCOUNT_FILE_ACTION = 'ACCOUNT_FILE_ACTION'
export const ACCOUNT_FILE_GET_PREVIEW = 'ACCOUNT_FILE_GET_PREVIEW'
export const ACCOUNT_FILE_UPDATE = 'ACCOUNT_FILE_UPDATE'
export const ACCOUNT_FILE_DETAILS = 'ACCOUNT_FILE_DETAILS'
export const ACCOUNT_FILES_DELETE = 'ACCOUNT_FILES_DELETE'
export const ACCOUNT_REFRESH_TOKEN = 'ACCOUNT_REFRESH_TOKEN'
export const ACCOUNT_SHOW_TOUR = 'ACCOUNT_SHOW_TOUR'
export const ACCOUNT_EXPORT_DOWNLOAD = 'ACCOUNT_EXPORT_DOWNLOAD'



// WEBPACK FOOTER //
// ./src/store/actions/accounts.js